import {
    CONFIRMED_CREATE_OFFER_ACTION,
    CONFIRMED_DELETE_OFFER_ACTION,
    CONFIRMED_EDIT_OFFER_ACTION,
    CONFIRMED_GET_OFFERS,
    CREATE_OFFER_ACTION,    
    CREATE_OFFER_ERROR_ACTION,
    CLEAR_OFFER_ERROR,
    LOADING_OFFERS
} from '../actions/OfferTypes';

const initialState = {
    offers: [],
    loading: false,
    createOfferError: {}
};

export default function OfferReducer(state = initialState, actions) {
    if (actions.type === CREATE_OFFER_ACTION) { 
        return {
            ...state,
            offers: [...state.offers],
        };
    }

    if (actions.type === CONFIRMED_DELETE_OFFER_ACTION) {
        const offers = state.offers.filter(offer => offer.id !== actions.payload);
        return {
            ...state,
            offers,
        };
    }

    if (actions.type === CONFIRMED_EDIT_OFFER_ACTION) {
        const offers = state.offers.map(offer => 
            offer.id === actions.payload.id ? actions.payload : offer
        );
        return {
            ...state,
            offers,
        };
    }

    if (actions.type === CONFIRMED_CREATE_OFFER_ACTION) {
        return {
            ...state,
            offers: [...state.offers, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_OFFERS) {
        return {
            ...state,
            offers: actions.payload,
        };
    }

    if (actions.type === LOADING_OFFERS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_OFFER_ERROR_ACTION) {
        return {
            ...state,
            createOfferError: actions.payload,
        };
    }

    if (actions.type === CLEAR_OFFER_ERROR) {
        return {
            ...state,
            createOfferError: {},
        };
    }
    
    return state;
}
